import { StarIcon } from '@braskai/icons';

import { Stack, Typography, useTheme } from '@mui/material';

import { STARS } from '../Quote/constants';
import { SAvatar, SContainer, SContent, SStarsContainer } from './styled';

type TQuoteProps = {
  name: string;
  avatar: string;
  role: string;
  text: string;
};

export const Quote = ({ name, avatar, role, text }: TQuoteProps) => {
  const { palette } = useTheme();
  return (
    <SContainer gap={24} justifyContent="space-between">
      <Typography color={palette.grey[900]} variant="body-2-md">
        {text}
      </Typography>
      <SContent alignItems="end" direction="row" gap={8}>
        <SAvatar src={avatar} />
        <Stack>
          <Typography color={palette.grey[900]} variant="caption-1-md">
            {name}
          </Typography>
          <Typography color={palette.grey[500]} variant="caption-2-md">
            {role}
          </Typography>
        </Stack>

        <SStarsContainer>
          {STARS.map((starIdx) => (
            <StarIcon key={starIdx} height={12} width={12} />
          ))}
        </SStarsContainer>
      </SContent>
    </SContainer>
  );
};
